/**
 * The support grant this browser tab is currently looking at a store under.
 *
 * sessionStorage, not localStorage, on purpose: it belongs to this tab and dies
 * with it, so closing the tab ends the "view" rather than leaving a grant id
 * lying around to be picked up on the next visit. It is only an identifier — the
 * API decides, on every request, whether it is still live and whose it is, so
 * holding or even stealing the value grants nothing without the operator's own
 * signed-in session.
 */

const KEY = 'mp_support_grant';

export function getSupportGrantId(): string | null {
  try {
    return sessionStorage.getItem(KEY);
  } catch {
    // Storage blocked (private mode, policy): no support session.
    return null;
  }
}

export function setSupportGrantId(grantId: string): void {
  try {
    sessionStorage.setItem(KEY, grantId);
  } catch {
    // Without storage the view cannot persist across a reload; nothing to do.
  }
}

export function clearSupportGrant(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // Nothing to clear.
  }
}
